import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useCancelWithdrawal(
  onSuccess?: () => void,
  onError?: (error: unknown) => void
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();
  const queryClient = useQueryClient();

  const cancelMutation = useMutation({
    ...trpc.withdrawals.cancel.mutationOptions(),
    onSuccess,
    onError,
  });

  const cancelWithdrawal = (id: string) => {
    if (!merchant?.id) return;

    cancelMutation.mutate(
      { rentalsMerchantId: merchant.id, id },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: trpc.withdrawals.list.queryKey(),
          });
          queryClient.invalidateQueries({
            queryKey: trpc.ledgerMovements.getBalance.queryKey(),
          });
        },
      }
    );
  };

  return { cancelWithdrawal, isCancelling: cancelMutation.isPending };
}
